import React from "react";
import { useEffect, useState } from "react";
import "./menu.css";
import { getAWSUrl } from "../api/core";
import Global from "../../global";
import { Link } from "react-router-dom";
import Anchor from "../Link/anchor";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { clearOut } from "../login/logout";
import { useHistory } from "react-router-dom";
import { DarkModeStore } from "../store/darkModeStore";
import {
  getSetting,
  intializeSetting,
  setSetting,
  isEmpty,
  saveSetting,
} from "../javascript/function";
import InPlayer from "../backend/inplayer";
const Menu = (props) => {
  const [transform, setTransform] = useState(false);
  const [stickyClass, setStickyClass] = useState(false);
  const [menuSchema, setMenu] = useState([]);
  const theme = DarkModeStore.useState((s) => s.themeMode);
  const [themeType, setTheme] = useState(theme);
  const [userMenu, SetUserMenu] = useState(false);
  const [lastMenu, setLastMenu] = useState([]);
  const [fullMenu, setFullMenu] = useState([]);
  const [search, SetSearch] = useState(false);
  const [searchText, setSearchText] = useState();
  let history = useHistory();
  const [branding, setBranding] = useState(
    localStorage.getItem("prev_logo") ? localStorage.getItem("prev_logo") : ""
  );
  const currentDate = new Date();

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);
    setBranding(props.branding);
    let firArr = props.data;
    setFullMenu(firArr);
    let newArray = firArr.sort(({ menuOrder: a }, { menuOrder: b }) => a - b);

    let fnewArray = newArray.filter(function (el, index) {
      return index < Global.Menu;
    });
    let lnewArray = newArray.filter(function (el, index) {
      return index >= Global.Menu;
    });

    setMenu(fnewArray);
    setLastMenu(lnewArray);

    return () => {
      window.removeEventListener("scroll", stickNavbar);
    };
  }, [props.branding, props.data]);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 200 ? setStickyClass(true) : setStickyClass(false);
    }
  };
  const Logout = (event) => {
    event.preventDefault();
    toastr.info("Logging Out", "Please Wait..");
    InPlayer.Account.signOut()
      .then((data) => {
        toastr.clear();
        clearOut();
        if (Global.LOGIN && Global.SUBSCRIPTION) {
          let path = "/" + props.match.params.AppId + "/welcome";
          history.push(path);
        } else if (!Global.LOGIN && Global.SUBSCRIPTION) {
          let path = "/" + props.match.params.AppId + "/home";
          history.push(path);
        } else if (Global.LOGIN && !Global.SUBSCRIPTION) {
          let path = "/" + props.match.params.AppId + "/welcome";
          history.push(path);
        } else {
          let path = "/" + props.match.params.AppId + "/home";
          history.push(path);
        }
      })
      .catch((error) => {
        toastr.error("Logout Failed", "Error");
      });
  };

  const changeThemeMode = (event) => {
    event.preventDefault();
    DarkModeStore.update((s) => {
      s.themeMode = !themeType;
    });
    setTheme(!themeType);

    let settings = getSetting();
    if (!isEmpty(settings)) {
      settings.DARK_MODE = !themeType;
      setSetting(settings);
      saveSetting(settings);
    } else {
      settings = intializeSetting();
      settings.DARK_MODE = !themeType;
      setSetting(settings);
      saveSetting(settings);
    }
  };
  const userNav = (event) => {
    event.preventDefault();
    SetUserMenu(!userMenu);
  };

  const changeDisplay = (event, _id, index) => {
    const ul = document.getElementById(_id);
    const li = document.getElementById(_id + index);
    const child = li.firstElementChild;
    if (ul.classList.contains("no-display")) {
      ul.classList.remove("no-display");
      child.classList.remove("fa-angle-down");
      child.classList.add("fa-angle-right");
    } else {
      ul.classList.add("no-display");
      child.classList.add("fa-angle-down");
      child.classList.remove("fa-angle-right");
    }
  };

  const handleClick = (event) => {
    setTransform(!transform);
  };
  const handleSearch = (event) => {
    event.preventDefault();
    SetSearch(!search);
  };

  const handleChange = (event) => {
    setSearchText(event.target.value);
    if (
      props.match.params.pageType !== "search" &&
      !props.match.params.searchId
    ) {
      let path =
        "/" + props.match.params.AppId + "/search/" + event.target.value;
      history.push(path);
    } else if (
      props.match.params.pageType === "search" &&
      !props.match.params.searchId
    ) {
      let path =
        "/" + props.match.params.AppId + "/search/" + event.target.value;
      history.push(path);
    }
  };
  const clearSearch = (event) => {
    setSearchText("");
    if (
      props.match.params.pageType !== "search" &&
      !props.match.params.searchId
    ) {
      let path = "/" + props.match.params.AppId + "/search/";
      history.push(path);
    } else if (
      props.match.params.pageType === "search" &&
      !props.match.params.searchId
    ) {
      let path = "/" + props.match.params.AppId + "/search/";
      history.push(path);
    }
  };

  return (
    <header className="news-header">
      <div className={stickyClass ? "top-bar no-display" : "top-bar"}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4">
              <div className="top-time">
                <span>
                  {currentDate.toDateString() +
                    " " +
                    currentDate.toLocaleTimeString()}
                </span>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="top-nav float-right">
                <ul className="top-nav-ul">
                  <li>
                    <a href="#!">English</a>
                  </li>
                  <li>
                    <a href="#!">മലയാളം</a>
                  </li>
                  <li>
                    <a href="#!">हिन्दी</a>
                  </li>
                  <li>
                    <a href="#!">தமிழ்</a>
                  </li>
                  <li>
                    <a href="#!">తెలుగు</a>
                  </li>
                  <li>
                    <a href="#!">ಕನ್ನಡ</a>
                  </li>
                  <li>
                    <a href="#!">ਪੰਜਾਬੀ</a>
                  </li>
                  <li>
                    <a href="#!"> русский язык</a>
                  </li>
                  <li className="top-sub-menu">
                    <a href="#!">More</a>
                    <div className="sub-menu-div">
                      <ul className="sub-menu-ul">
                        <li>
                          <a href="#!">Games</a>
                        </li>
                        <li>
                          <a href="#!">Contest</a>
                        </li>
                        <li>
                          <a href="#!">Feedback</a>
                        </li>
                        <li>
                          <a href="#!">Spanish</a>
                        </li>
                        <li>
                          <a href="#!">Korean</a>
                        </li>
                        <li>
                          <a href="#!">Russian</a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={stickyClass ? "main-header no-display" : "main-header"}>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-4">
              <span className="sidebarBtn" onClick={handleClick}>
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
              </span>
            </div>
            <div className="col-xl-4 col-lg-3">
              <div className="site-branding">
                <Link
                  className="dark-logo"
                  to={"/" + props.match.params.AppId + "/home"}
                >
                  <img
                    width={162}
                    height={52}
                    src={getAWSUrl() + branding}
                    alt="logo"
                  />
                </Link>
              </div>
            </div>
            <div className="col-xl-3 col-lg-2">
              <ul className="iconUl">
                {Global.DARK_MODE ? (
                  <li className="dark-mode">
                    <Link to="#!" onClick={changeThemeMode}>
                      <i
                        className={
                          props.theme ? "ri-moon-line" : "ri-moon-fill"
                        }
                      />
                      <span className="tooltiptext">
                        {props.theme ? "Enable Light Mode" : "Enable Dark Mode"}
                      </span>
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                <li className={search ? "now-index" : ""}>
                  <Link
                    to="#!"
                    className="search-toggle device-search"
                    onClick={handleSearch}
                  >
                    <i className="fa fa-search" />
                  </Link>
                  <div className="search-box iq-search-bar d-search">
                    <form action="#" className="searchbox">
                      <div className="form-group position-relative">
                        <input
                          type="text"
                          className="text search-input font-size-12"
                          placeholder="Search..."
                          onChange={handleChange}
                          value={searchText}
                        />
                        <i className="search-link ri-search-line" />
                        <div
                          className="Search_Button Search_Wrap"
                          aria-label="Clear search"
                          role="button"
                          tabIndex="0"
                          onClick={clearSearch}
                        >
                          <svg
                            className="Search_SVG"
                            viewBox="0 0 18 18"
                            focusable="false"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M9 1C4.58 1 1 4.58 1 9s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4 10.87L11.87 13 9 10.13 6.13 13 5 11.87 7.87 9 5 6.13 6.13 5 9 7.87 11.87 5 13 6.13 10.13 9 13 11.87z"></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </form>
                  </div>
                </li>
                <li
                  className={
                    !Global.SUBSCRIPTION && !Global.LOGIN
                      ? "sub-list no-display"
                      : "sub-list"
                  }
                >
                  <Link to="#!" onClick={userNav}>
                    <i className="fa fa-user" />
                  </Link>
                  <ul
                    className={
                      userMenu ? "final-dropdown now-display" : "final-dropdown"
                    }
                    onMouseLeave={() => {
                      SetUserMenu(false);
                    }}
                  >
                    <li>
                      <Link to={"/" + props.match.params.AppId + "/profile"}>
                        Profile & Settings
                      </Link>
                    </li>
                    {Global.FAVOURITES ? (
                      <li>
                        <Link
                          to={"/" + props.match.params.AppId + "/favourites"}
                        >
                          Favourites
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {Global.WATCHHISTORY ? (
                      <li>
                        <Link
                          to={"/" + props.match.params.AppId + "/watchhistory"}
                        >
                          Watch History
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}

                    <li>
                      <Link to="#!" onClick={Logout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          stickyClass ? "menu-wrapper no-top fixed-top" : "menu-wrapper"
        }
      >
        <div className="final-header">
          <div className="container-fluid">
            <ul
              className={
                Global.FLOAT === "left"
                  ? "finalUl text-left"
                  : Global.FLOAT === "right"
                  ? "finalUl text-right"
                  : "finalUl"
              }
            >
              {menuSchema.map((person, index) =>
                person.menuType !== "multiple" ? (
                  <li key={index}>
                    <Anchor
                      className={
                        props.match.url ===
                          "/" +
                            props.match.params.AppId +
                            "/" +
                            person.urlName ||
                        props.match.url ===
                          "/" +
                            props.match.params.AppId +
                            "/page/" +
                            person.menuPage
                          ? "active"
                          : props.match.url ===
                              "/" + props.match.params.AppId &&
                            person.urlName === "home"
                          ? "active"
                          : ""
                      }
                      to={"/" + props.match.params.AppId + "/" + person.urlName}
                    >
                      {person.menuTitle}
                    </Anchor>
                  </li>
                ) : person.items !== null && person.items.length > 0 ? (
                  <li className="sub-list" key={index}>
                    <Link to="#!">{person.menuTitle}</Link>
                    <ul className="final-dropdown">
                      {person.items.map((item, index) => (
                        <li key={item._id}>
                          <Anchor
                            className={
                              props.match.url ===
                                "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.menuUrlName ||
                              props.match.url ===
                                "/" +
                                  props.match.params.AppId +
                                  "/page/" +
                                  item.menuPage
                                ? "active"
                                : props.match.url ===
                                    "/" + props.match.params.AppId &&
                                  item.menuUrlName === "home"
                                ? "active"
                                : ""
                            }
                            to={
                              "/" +
                              props.match.params.AppId +
                              "/" +
                              item.menuUrlName
                            }
                          >
                            {item.menuTitle}
                          </Anchor>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li className="sub-list" key={index}>
                    {" "}
                    <Link to="#!">{person.menuTitle}</Link>
                  </li>
                )
              )}

              {lastMenu.length > 0 ? (
                <li className="sub-list" key={"moreMenu0289"}>
                  <Link to="#!">{"More"}</Link>
                  <ul className="final-dropdown final-dropdown-list">
                    {lastMenu.map((person, index) =>
                      person.menuType !== "multiple" ? (
                        <li key={index}>
                          <Anchor
                            className={
                              props.match.url ===
                                "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  person.urlName ||
                              props.match.url ===
                                "/" +
                                  props.match.params.AppId +
                                  "/page/" +
                                  person.menuPage
                                ? "active"
                                : props.match.url ===
                                    "/" + props.match.params.AppId &&
                                  person.urlName === "home"
                                ? "active"
                                : ""
                            }
                            to={
                              "/" +
                              props.match.params.AppId +
                              "/" +
                              person.urlName
                            }
                          >
                            {person.menuTitle}
                          </Anchor>
                        </li>
                      ) : person.items !== null && person.items.length > 0 ? (
                        <li className="dropdown-sub-list" key={index}>
                          <Link to="#!"> {person.menuTitle}</Link>
                          <ul className="dropdown-list">
                            {person.items.map((item, index) => (
                              <li key={item._id}>
                                <Anchor
                                  className={
                                    props.match.url ===
                                      "/" +
                                        props.match.params.AppId +
                                        "/" +
                                        item.menuUrlName ||
                                    props.match.url ===
                                      "/" +
                                        props.match.params.AppId +
                                        "/page/" +
                                        item.menuPage
                                      ? "active"
                                      : props.match.url ===
                                          "/" + props.match.params.AppId &&
                                        item.menuUrlName === "home"
                                      ? "active"
                                      : ""
                                  }
                                  to={
                                    "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    item.menuUrlName
                                  }
                                >
                                  {item.menuTitle}
                                </Anchor>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ) : (
                        <li className="dropdown-sub-list" key={index}>
                          <Link to="#!">{person.menuTitle}</Link>
                        </li>
                      )
                    )}
                  </ul>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className="mobile-header">
        <div className="mobile-span">
          <span className="sidebarBtn" onClick={handleClick}>
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </span>
        </div>
        <div className="mobile-logo">
          <Link to={"/" + props.match.params.AppId + "/home"}>
            <img
              src={getAWSUrl() + branding}
              alt="neeon"
              width={162}
              height={52}
            />
          </Link>
        </div>
        <div className="mobile-final">
          <ul className="iconUl">
            {Global.DARK_MODE ? (
              <li className="dark-mode">
                <Link to="#!" onClick={changeThemeMode}>
                  <i
                    className={props.theme ? "ri-moon-line" : "ri-moon-fill"}
                  />
                  <span className="tooltiptext">
                    {props.theme ? "Enable Light Mode" : "Enable Dark Mode"}
                  </span>
                </Link>
              </li>
            ) : (
              ""
            )}
            <li className={search ? "now-index" : ""}>
              <Link
                to="#!"
                className="search-toggle device-search"
                onClick={handleSearch}
              >
                <i className="fa fa-search" />
              </Link>
              <div className="search-box iq-search-bar d-search">
                <form action="#" className="searchbox">
                  <div className="form-group position-relative">
                    <input
                      type="text"
                      className="text search-input font-size-12"
                      placeholder="Search..."
                      onChange={handleChange}
                      value={searchText}
                    />
                    <i className="search-link ri-search-line" />
                    <div
                      className="Search_Button Search_Wrap"
                      aria-label="Clear search"
                      role="button"
                      tabIndex="0"
                      onClick={clearSearch}
                    >
                      <svg
                        className="Search_SVG"
                        viewBox="0 0 18 18"
                        focusable="false"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <path d="M9 1C4.58 1 1 4.58 1 9s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4 10.87L11.87 13 9 10.13 6.13 13 5 11.87 7.87 9 5 6.13 6.13 5 9 7.87 11.87 5 13 6.13 10.13 9 13 11.87z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </form>
              </div>
            </li>

            <li
              className={
                !Global.SUBSCRIPTION && !Global.LOGIN
                  ? "sub-list no-display"
                  : "sub-list"
              }
            >
              <Link to="#!" onClick={userNav}>
                <i className="fa fa-user" />
              </Link>
              <ul
                className={
                  userMenu ? "final-dropdown now-display" : "final-dropdown"
                }
                onMouseLeave={() => {
                  SetUserMenu(false);
                }}
              >
                <li>
                  <Link to="/profile">Profile</Link>
                </li>
                <li>
                  <Link to="/profile">Settings</Link>
                </li>
                <li>
                  <Link to="/profile">Favourites</Link>
                </li>
                <li>
                  <Link to="/profile">Watch History</Link>
                </li>
                <li>
                  <Link to="/profile">Logout</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div
        className={transform ? "nav-content no-transform" : "nav-content"}
        tabIndex={0}
      >
        <div className="offcanvas-content">
          <div className="offcanvas-header">
            <div className="offcanvas-logo">
              <div className="site-branding">
                <Link
                  className="light-logo"
                  to={"/" + props.match.params.AppId + "/home"}
                >
                  <img
                    width={162}
                    height={52}
                    src={getAWSUrl() + branding}
                    alt="neeon"
                  />
                </Link>
              </div>
            </div>
            <div className="close-btn offcanvas-close" onClick={handleClick}>
              <Link to="#!">
                <i className="fa fa-times" />
              </Link>
            </div>
          </div>
        </div>
        <div className="offcanvas-middle">
          <ul>
            {fullMenu.map((person, index) =>
              person.menuType !== "multiple" ? (
                <li key={index}>
                  <Anchor
                    className={
                      props.match.url ===
                        "/" + props.match.params.AppId + "/" + person.urlName ||
                      props.match.url ===
                        "/" +
                          props.match.params.AppId +
                          "/page/" +
                          person.menuPage
                        ? "active"
                        : props.match.url === "/" + props.match.params.AppId &&
                          person.urlName === "home"
                        ? "active"
                        : ""
                    }
                    to={"/" + props.match.params.AppId + "/" + person.urlName}
                  >
                    {person.menuTitle}
                  </Anchor>
                </li>
              ) : person.items !== null && person.items.length > 0 ? (
                <li
                  className="sub-list"
                  key={index}
                  onClick={(event) => {
                    changeDisplay(event, person._id, index);
                  }}
                >
                  <Link to="#!" id={person._id + index}>
                    {person.menuTitle} <i className="fa fa-angle-down" />
                  </Link>
                  <ul className="no-display" id={person._id}>
                    {person.items.map((item, index) => (
                      <li key={item._id}>
                        <Anchor
                          className={
                            props.match.url ===
                              "/" +
                                props.match.params.AppId +
                                "/" +
                                item.menuUrlName ||
                            props.match.url ===
                              "/" +
                                props.match.params.AppId +
                                "/page/" +
                                item.menuPage
                              ? "active"
                              : props.match.url ===
                                  "/" + props.match.params.AppId &&
                                item.menuUrlName === "home"
                              ? "active"
                              : ""
                          }
                          to={
                            "/" +
                            props.match.params.AppId +
                            "/" +
                            item.menuUrlName
                          }
                        >
                          {item.menuTitle}
                        </Anchor>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li className="sub-list" key={index}>
                  {" "}
                  <Link to="#!">{person.menuTitle}</Link>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Menu;
